// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadAlbumAction } from '../../actions/album';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +entities: string,
  |},
  loading: boolean,
};

const initialState = {
  loading: false,
};

export default function albums(state: State = initialState, action: LoadAlbumAction): State {
  if (action.type === 'FETCH_ALBUM' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
